import expressOrderDialog from './transport-consignment-express-order'

export default {
  title: '运输委托单',
  list: {
    filterTitle: '运输委托单筛选',
    exportTitle: '运输委托单列表'
  },
  batch: {
    selectedCount: '已选 {count} 条',
    confirmFee: '批量确认费用',
    cancelConfirmFee: '批量取消确认费用',
    complete: '批量完结'
  },
  batchComplete: {
    title: '批量完结',
    tip: '请确认以下委托单下属运单的完结信息。完成时间为运单最后一个运踪节点的实际完成时间，选填；不填则仅将运单及最后一个运踪节点置为已完成，不记录实际时间。',
    confirm: '确认完结',
    cancel: '取消',
    actualTimePlaceholder: '请选择完成时间',
    columns: {
      consignmentNo: '委托单号',
      waybillNo: '运单号',
      actualTime: '完成时间'
    }
  },
  actions: {
    add: '新增',
    expand: '展开',
    collapse: '收起',
    detail: '详情',
    rateQuery: '运价查询',
    inquiry: '询价',
    spaceInquiry: '询舱',
    confirmSpace: '确认舱位',
    delegate: '委托',
    delegateSupplier: '委托供应商',
    contactSupplier: '联系供应商',
    offlineConfirm: '线下委托确认',
    quickOrder: '快递下单',
    getExpressLabel: '获取面单',
    split: '拆单',
    resplit: '再拆单',
    notifyPicking: '通知拣货出库',
    cancelConsignment: '取消委托',
    deleteConsignment: '删除委托单',
    confirmDeleteConsignment: '确认删除',
    delete: '删除',
    unfreeze: '解冻',
    edit: '编辑',
    share: '分享',
    print: '打印',
    operationHistory: '操作历史'
  },
  resplit: {
    title: '再拆单',
    confirm: '确认再拆',
    cancel: '取消',
    strategy: '拆单方式',
    strategyOptions: {
      2: '三段：港前｜干线｜尾程',
      3: '两段：港前+干线｜尾程',
      4: '两段：港前｜干线+尾程',
      preMainIndependent: '两段：港前｜干线',
      mainLastIndependent: '两段：干线｜尾程'
    },
    strategySummaryNames: {
      2: '三段拆分',
      3: '两段拆分（港前+干线｜尾程）',
      4: '两段拆分（港前｜干线+尾程）',
      preMainIndependent: '两段拆分（港前｜干线）',
      mainLastIndependent: '两段拆分（干线｜尾程）'
    },
    transportSegments: '运输段落',
    strategyDescription: '{strategy}：原单保留「{sourceSegment}」，{childSegments}生成新委托单，合计 {count} 张委托单。',
    originWarehouse: '发货仓库',
    destinationAddress: '收货地址/城市',
    loadingEndpoint: '干线起运端点',
    dischargeEndpoint: '干线目的端点',
    loadingCountry: '起运国',
    loadingPort: '起运港',
    dischargeCountry: '目的国',
    dischargePort: '目的港',
    selectCountry: '请选择国家',
    selectPort: '请选择港口/机场/口岸',
    portCountryRequired: '国家信息缺失，请先切换国家模式补全国家',
    portSearchFailed: '港口/机场查询失败，请重新打开下拉框重试',
    willGenerate: '再拆后共',
    consignmentUnit: '张委托单',
    newPlanTip: '· 新单关联同段新建的运输计划单',
    sourceOrder: '原单',
    newOrder: '新单{index}',
    table: {
      consignment: '委托单',
      planNo: '计划单号',
      transportSegment: '运输段落',
      segmentOrigin: '本段起运地',
      segmentDestination: '本段目的地'
    },
    entrustedTip: '发货/收货地址保持不变；原单保留供应商及委托关系，并新增实际送达地，直接承接的第一张新单新增实际提货地；其余新单不写交接地址。',
    notEntrustedTip: '发货/收货地址保持不变；新单按未委托状态创建，不继承供应商、询价、运价、费用、账单、运踪和运单；原单已有确认运价时清理与原组合路线绑定的运价。',
    success: '运输委托单再拆成功'
  },
  expand: {
    title: '委托单 {no}',
    placeholder: '展开内容待设计'
  },
  editDialog: {
    title: '编辑运输委托单',
    createTitle: '新建运输委托单',
    createSubtitle: '手工创建新的运输委托单',
    save: '保存',
    cancel: '取消',
    discardConfirmTitle: '是否放弃当前修改？',
    stay: '留在此页',
    discard: '放弃修改',
    addNotify: '添加通知人',
    amountPlaceholder: '请选择计算结果或手动输入',
    calculatedByProducts: '按商品计算 {amount}',
    goodsReadySingleDay: '单日',
    goodsReadyPeriod: '区间',
    manualCreate: '手工创建'
  },
  offlineConfirmDialog: {
    title: '线下委托确认',
    content: '确认已通过线下方式委托供应商「{supplier}」承运本委托单（{no}）？确认后委托状态将变更为「已委托」，运价确认状态、舱位确认状态将变更为「无关」。',
    okText: '确认已委托',
    cancelText: '取消'
  },
  offlineSupplierDialog: {
    title: '线下委托供应商',
    supplierName: '供应商名称',
    supplierNamePlaceholder: '请选择供应商',
    contactName: '联系人',
    contactNamePlaceholder: '请输入联系人',
    contactPhone: '联系方式',
    contactPhonePlaceholder: '请输入联系方式',
    contactEmail: '邮箱',
    contactEmailPlaceholder: '请输入邮箱',
    okText: '确认委托',
    cancelText: '取消'
  },
  expressCancelDialog: {
    title: '取消快递委托',
    content: '确认取消本快递委托单（{no}）？取消后将撤销已下的快递订单并删除对应运单，且不会发送邮件通知。',
    okText: '确认取消',
    cancelText: '取消'
  },
  offlineCancelDialog: {
    title: '取消委托',
    content: '本单为线下委托单据，取消委托仅取消本委托单委托状态，请到原线下委托平台取消实际委托。',
    okText: '确认取消',
    cancelText: '取消'
  },
  inquiryDialog: {
    title: '询价',
    segmentTip: '当前版本按本委托单运输段落发起询价，暂不支持跨段落联合询价',
    rateQuerySegmentTip: '按本委托单运输段落及当前航线条件查询运价库；多选运输业务类型时，各 Tab 独立查询和选择。',
    transportRoute: '运输方式',
    onePriceSupported: 'All In 价格',
    quoteDeadline: '报价截止时间',
    goodsReadyDate: '单日',
    goodsReadyRange: '区间',
    carrier: '船公司',
    shippingCompany: '船公司',
    airline: '航空公司',
    railwayCompany: '铁路公司',
    optional: '（可不指定）',
    carrierUnspecified: '不指定',
    businessModes: '选择运输业务类型（可多选）',
    cargoGroup: '货物组',
    vehicleGroup: '车辆组',
    bulkCargoInfo: '货物信息',
    summary: '合计：{qty} 件 / {weight} KGS / {volume} CBM',
    vehicleSummary: '合计：{qty} 辆 / {weight} KGS',
    bulkSummary: '合计：{weight} MT / {volume} CBM',
    queryExistingRates: '查询现有运价',
    query: '查询',
    rateWriteBackFullTip: '选定运价并确认后，将回写本段委托单及关联委托单的相接路线。建议先确定包含干线的航线信息。所选相接路线为空或与关联侧一致时，即使关联单已委托也可确认；空值不清空关联单已有路线。所选非空路线与已委托关联单不一致时，本次确认不回写本单与关联单。未委托关联侧为空则自动填充，非空且不一致时可确认覆盖或取消重选。',
    rateWriteBackShortTip: '确认后将同步回写关联委托单相接路线；建议先定含干线的航线。',
    routeInfo: '航线信息',
    routeFilterTitle: '航线信息筛选框',
    expand: '展开',
    collapse: '收起',
    originCountry: '起运国',
    destinationCountry: '目的国',
    loadingPort: '起运港/机场',
    dischargePort: '目的港/机场',
    loadingAirport: '起运机场',
    dischargeAirport: '目的机场',
    originWarehouse: '起运仓库',
    destinationWarehouse: '目的仓库',
    originPlace: '起运地',
    destinationPlace: '目的地',
    routeConflictTitle: '关联委托单相接路线不一致',
    routeConflictContent: '关联委托单存在非空且不一致的同名航线字段。是否采用本单值同步覆盖？',
    routeConflictDescription: '以下相接侧起运港/目的港、机场或国家与关联单现有非空值不一致。关联单未委托时，可确认回写为本单所选运价值；也可取消后重新选价。',
    routeBlockedDescription: '关联委托单【{nos}】已委托，且本单所选运价的非空相接路线（起运港/目的港、机场或国家）与关联单不一致，本次无法确认回写。请取消后重新选价。',
    sameSegmentBlockedTitle: '存在重复运输段落',
    sameSegmentBlockedDescription: '关联委托单【{nos}】与当前委托单属于相同运输段落，无法确认运价。请先处理重复委托单后重试。',
    confirmRouteWriteBack: '确认回写',
    routeConflictColumns: {
      relatedConsignmentNo: '关联委托单',
      transportSegment: '运输段落',
      field: '字段',
      relatedCurrent: '关联单现有',
      proposed: '本单拟回写'
    },
    useCurrentRoute: '采用本单值',
    cancelAndReselect: '取消重选',
    routeBlockedTitle: '已委托关联单相接路线不一致',
    routeBlockedContent: '关联委托单【{nos}】已委托，且本单所选运价的非空相接路线与关联单不一致，本次确认不会回写本单与关联单，请取消并重新选择。',
    rateResults: {
      found: '找到 {count} 条',
      tabFcl: '海运整箱',
      tabLcl: '海运拼箱',
      tabAir: '空运',
      tabPrePort: '港前陆运',
      tabLastMile: '尾程陆运',
      tabFullCombination: '全程组合运价',
      tabPreMainCombination: '港前+干线组合运价',
      tabMainLastCombination: '干线+尾程组合运价',
      routePorts: '起运港 / 卸货港',
      originAirportLabel: '起运机场',
      destinationAirportLabel: '目的机场',
      countUnit: '条',
      sourceContract: '合约',
      sourceInquiry: '单询',
      sourceQuotation: '报价',
      sourceManual: '手工录入',
      sortLabel: '排序：',
      sortPrice: '价格最优',
      sortTransit: '时效最优',
      transitLabel: '航程：',
      dayUnit: '天',
      validLabel: '有效期至：',
      validity: '有效期',
      validityLabel: '有效期：',
      etdLabel: '最早ETD：',
      minChargeLabel: '最低计费',
      wmUnitRateLabel: 'W/M 单价',
      kgUnitRateLabel: 'KG 单价',
      baseFreightUnitLabel: '基础运费',
      airWeightTierUnitRateLabel: '{tier} 单价',
      normalRateUnitRateLabel: 'N 单价',
      applicableAirRateLabel: '适用单价',
      estimatedFreightLabel: '预估运费',
      chargeableWeightLabel: '计费重：',
      chargeableWeightValue: '{value} KG',
      calculatedFreightLabel: '计算运费：',
      minimumChargeDetailLabel: '最低消费：',
      minimumAppliedLabel: '（已生效）',
      minShipmentLabel: '最低一票',
      totalPriceLabel: '费用合计',
      priceRangeLabel: '价格区间',
      roadTransport: '陆运',
      roadPriceUnit: '/票',
      minMaxUnit: '最小/最大',
      ticketUnit: '/票',
      ticketStartUnit: '/票起',
      airPriceLabel: '计费量/kg',
      remarksTitle: '备注信息',
      supplierLabel: '供应商：',
      laneCodeLabel: '航线代码：',
      airlineLabel: '航空公司：',
      priceNoLabel: '运价编码：',
      fullCombinationPrePort: '港前：',
      fullCombinationTrunk: '干线：',
      fullCombinationLastMile: '尾程：',
      fullCombinationRoute: '全程路线：',
      fullCombinationPrePortNo: '港前运价：',
      fullCombinationTrunkNo: '干线运价：',
      fullCombinationLastMileNo: '尾程运价：',
      receivingLabel: '接货特殊说明：',
      shippingTipLabel: '起运提示：',
      weightLimitText: '限重 {value}T',
      freeBoxLabel: '免箱免堆：',
      freeBoxSeparator: '，',
      detentionDays: '免用箱{days}天',
      demurrageDays: '免堆存{days}天',
      remarkLabel: '备注：',
      cargoTypeText: '货物类型 {value}',
      cargoDescText: '货物描述 {value}',
      spotQuote: '电询',
      periodEndOnly: '至 {date}',
      periodStartOnly: '{date} 起',
      directAir: '直飞',
      directSea: '直达',
      transfer: '中转',
      directTransferAir: '直飞+中转',
      directTransferSea: '直达+中转',
      unspecified: '不指定',
      weekdaySeparator: '、',
      weekdays: {
        mon: '周一',
        tue: '周二',
        wed: '周三',
        thu: '周四',
        fri: '周五',
        sat: '周六',
        sun: '周日'
      },
      specialInstructionsLabel: '特殊说明：',
      noResults: '未找到符合条件的运价',
      noResultsValidityHint: '请核对本段期望收/发货时间是否在运价有效期范围内。'
    },
    shouldInquiry: '是否询价',
    missingIsoCode: '（缺少ISO代码）',
    containerTypeLoadFailed: '加载集装箱基础数据失败',
    supplierSelector: {
      searchPlaceholder: '搜索供应商名称、联系人关键词',
      region: '区域',
      notSet: '未设置',
      noData: '暂无匹配供应商',
      noContacts: '暂无联系人',
      selectSupplier: '请选择供应商查看详情',
      selectAll: '全选',
      selectedCount: '已选 {count} 个联系人',
      contact: '联系人',
      phone: '电话',
      email: '邮箱',
      evaluation: '供应商评价',
      noEvaluation: '暂无供应商评价',
      noEvaluationItems: '暂无评价项明细',
      modeUnsupported: '请选择支持询价的运输业务类型后查询供应商',
      loadFailed: '加载询价目标供应商失败'
    },
    addContainer: '添加箱型',
    addCargo: '添加货物',
    addVehicle: '添加车辆',
    addBulkCargo: '添加货物信息',
    delete: '删除',
    cancel: '取消',
    close: '关闭',
    confirm: '确认',
    confirmSelection: '确认选择',
    routes: {
      direct: '直达',
      transfer: '中转',
      unspecified: '不指定'
    },
    fieldLabels: {
      containerType: '箱型',
      containerQty: '数量',
      outboxQty: '件数',
      containerWeight: '重量(KGS)',
      containerSize: '尺寸（长×宽×高 cm）',
      containerLength: '长（cm）',
      containerWidth: '宽（cm）',
      containerHeight: '高（cm）',
      packaging: '包装类型',
      grossWeight: '毛重(KGS)',
      volume: '体积(CBM)',
      length: '长（cm）',
      width: '宽（cm）',
      height: '高（cm）',
      palletQty: '托盘数量',
      vehicleType: '车辆类型',
      vehicleQty: '数量',
      vehicleBrand: '品牌',
      vehicleModel: '型号',
      brand: '品牌',
      model: '型号',
      vehicleLength: '车长(M)',
      vehicleWidth: '车宽(M)',
      vehicleHeight: '车高(M)',
      vehicleWeight: '毛重(KGS)',
      cargoKind: '货种',
      cargoWeight: '吨位(MT)',
      cargoVolume: '体积(CBM)',
      tonnage: '吨位(MT)',
      stowageFactor: '积载因数',
      summaryRow: '汇总',
      totalVehicleQty: '总车辆',
      totalVehicleWeight: '总毛重',
      vehicleRlm: '车位米',
      totalTonnage: '总吨位',
      totalCubage: '总体积',
      averageStowageFactor: '平均积载因数',
      packagingType: '包装方式',
      remark: '备注',
      remarks: '备注',
      operation: '操作'
    },
    vehicleTypes: {
      sedan: '轿车',
      suv: 'SUV',
      mpv: 'MPV',
      pickup: '皮卡',
      truck: '卡车',
      bus: '客车',
      machinery: '工程机械',
      other: '其他'
    },
    cargoKinds: {
      steel: '钢材',
      coal: '煤炭',
      ore: '矿石',
      grain: '粮食',
      timber: '木材',
      fertilizer: '化肥',
      cement: '水泥',
      sandStone: '沙石',
      other: '其他'
    },
    placeholders: {
      containerType: '请选择箱型',
      transportTerms: '请选择运输条款',
      cargoType: '请选择货物类型',
      quoteDeadline: '请选择报价截止时间',
      goodsReadyTimeType: '请选择货好时间类型',
      goodsReadyTime: '请选择货好日期',
      goodsReadyTimeStart: '开始日期',
      goodsReadyTimeEnd: '结束日期',
      shippingCompany: '请选择船公司',
      airline: '请选择航空公司',
      railwayCompany: '请输入铁路公司',
      packaging: '请选择包装类型',
      grossWeight: '毛重(KGS)',
      volume: '体积(CBM)',
      length: '长',
      width: '宽',
      height: '高',
      vehicleType: '请选择车辆类型',
      brand: '请输入品牌',
      model: '请输入型号',
      cargoKind: '请选择货种',
      packagingType: '请选择包装方式',
      remark: '备注'
    }
  },
  selectedRate: {
    title: '已选运价',
    loading: '正在加载已选运价',
    noData: '未查询到已绑定运价',
    feeDetail: '费用明细',
    sailingConfirmTip: '建议询舱二次确认：{fields} 缺失',
    fields: {
      etd: 'ETD：',
      eta: 'ETA：',
      vesselVoyage: '船名/航次：',
      flightNo: '航班号：',
      vesselNameOnly: '船名',
      voyageNoOnly: '航次',
      laneCodeOnly: '航线代码',
      airlineOnly: '航空公司',
      flightNoOnly: '航班号'
    }
  },
  tracking: {
    empty: '暂无运踪轨迹',
    fields: {
      waybillNo: '运单号',
      expressNo: '快递单号',
      supplierName: '供应商/快递商',
      trackingNode: '运踪节点',
      trackingTime: '节点时间',
      trackingDesc: '节点描述',
      trackingSource: '来源',
      operator: '操作人',
      orderStatus: '主状态',
      hasException: '异常'
    },
    waybill: {
      actions: {
        create: '新建运单',
        refreshTracking: '刷新运踪',
        packingDetail: '装箱明细',
        getPod: '获取POD',
        podFetching: '获取POD中',
        podFetched: '已获取POD',
        deleteWaybill: '删除运单',
        cancel: '取消',
        confirm: '确定'
      },
      docType: {
        transportWaybill: '运输单'
      },
      empty: {
        notConsigned: '该委托单尚未委托，暂无运踪记录',
        noWaybill: '暂无运单运踪',
        noNode: '暂无运踪节点'
      },
      tooltip: {
        notConsigned: '委托单尚未委托，无法新建运单',
        waybillNo: '海运：HBL/MBL；空运：HAWB/MAWB；快递：快递运单号；陆运：承运商运单号；铁路：铁路运单号'
      },
      modal: {
        title: '新建运单',
        baseInfo: '基础信息',
        transportInfo: '运输信息'
      },
      pod: {
        title: '获取POD',
        loading: '正在获取POD...',
        success: 'POD获取成功！',
        saved: '已保存到文件管理和签收节点附件',
        failed: '获取POD失败',
        retry: '重试',
        close: '关闭',
        defaultError: '获取POD失败，请稍后重试',
        stillPending: '快递供应商暂未返回签收回单，请稍后重试',
        serviceUnavailable: 'POD服务暂时不可用，请稍后重试',
        trackingNoMissing: '当前运单缺少可用于查询POD的快递跟踪号',
        fileSaveFailed: 'POD文件保存失败，请稍后重试',
        recordSaveFailed: 'POD请求记录保存失败，请稍后重试',
        invalidResponse: 'POD服务返回的数据无法识别，请稍后重试',
        statusFailed: '查询POD状态失败',
        fetchFailed: '获取POD失败'
      },
      deleteConfirm: {
        title: '确认删除运单？',
        content: '删除运单 {no} 后，运单列表及本页运踪数据会同步删除。',
        okText: '确认删除',
        cancelText: '取消'
      },
      placeholders: {
        select: '请选择{field}',
        packageBarcode: '请输入条码后按回车添加'
      },
      timePrefixes: {
        estimated: '预',
        actual: '实'
      },
      duration: {
        dayHour: '{days}天{hours}小时',
        day: '{value}天',
        hour: '{value}小时'
      },
      fields: {
        mainTransportMode: '本段运输业务类型',
        blType: '运单号-提单类型',
        blNo: '运单号-提单号',
        expressWaybillNo: '运单号-快递单号',
        orderNo: '运单号-合作号',
        segmentOrigin: '本段起运地',
        segmentDestination: '本段目的地',
        originPort: '起运港',
        destinationPort: '目的港',
        transshipmentPort: '中转港',
        originAirport: '起飞机场',
        destinationAirport: '目的机场',
        transshipmentAirport: '中转机场',
        originPlace: '起运地',
        destinationPlace: '目的地',
        originStation: '起运站',
        destinationStation: '目的站',
        shipowner: '船公司',
        vesselName: '船名',
        voyageNo: '航次',
        lineCode: '航线代码',
        airline: '航空公司',
        flightNo: '航班号',
        truckCo: '陆运公司',
        vehicleLicence: '车牌号',
        driverName: '司机姓名',
        driverPhone: '电话',
        driverIdNo: '身份证号',
        vehicleType: '车型',
        railwayCo: '铁路公司',
        trainNo: '班次号',
        expressCompany: '快递公司',
        expressCarrier: '快递承运商',
        expressProduct: '快递产品',
        packageBarcode: '货物包裹条码',
        supplierName: '供应商',
        remark: '备注',
        consignmentNo: '关联委托单号',
        fhNo: '关联 FH 单号',
        transportSegment: '运输段落',
        transportTool: '交通工具',
        shipper: '承运商',
        createdAt: '创建时间',
        exceptionLevel: '异常等级',
        estimatedTime: '预计时间',
        actualTime: '实际时间',
        estimatedRemark: '预计备注',
        actualRemark: '实际备注',
        exceptionRemark: '异常备注',
        attachment: '附件'
      },
      summary: {
        separator: '：',
        relatedWaybillNo: '关联运单号',
        shippingCompany: '船公司',
        vesselName: '船名',
        voyageNo: '航次',
        lineCode: '航线代码',
        airline: '航空公司',
        flightNo: '航班号',
        aircraftType: '机型',
        expectedDuration: '预期航程',
        actualDuration: '实际航程',
        expressCarrier: '快递承运商',
        expressProduct: '快递产品',
        railTrain: '铁路班车',
        vehicleLicence: '车牌号'
      },
      messages: {
        loadFailed: '加载运单运踪失败',
        notConsigned: '委托单尚未委托，无法新建运单',
        transportModeRequired: '当前委托单缺少本段运输业务类型，无法新建运单',
        blTypeRequired: '请选择提单类型',
        blNoRequired: '请填写提单号',
        expressWaybillNoRequired: '请填写快递单号',
        packageBarcodeRequired: 'DHL 承运商需至少填写一个货物包裹条码',
        packageBarcodeDuplicate: '货物包裹条码不能重复',
        orderNoRequired: '请填写合作号',
        vehicleLicenceRequired: '请填写车牌号',
        truckPlateInvalid: '车牌号格式不正确',
        orderIdRequired: '缺少运输委托单ID，无法新建运单',
        waybillIdRequired: '缺少运单ID，无法删除',
        createSuccess: '运单创建成功',
        createFailed: '新建运单失败',
        deleteSuccess: '运单已删除',
        deleteFailed: '删除运单失败，请重试',
        etowerRetrySuccess: '已重新提交推送任务',
        etowerAlreadySuccess: '订单已推送成功，无需重复推送',
        etowerUnknownWarning: '推送结果未知，请先人工核查',
        etowerRetryFailed: '重新推送订单失败，请重试',
        shipownerLoadFailed: '加载船公司数据失败',
        airlineLoadFailed: '加载航空公司数据失败',
        expressCarrierLoadFailed: '加载快递承运人数据失败',
        fieldRequired: '{field}不能为空',
        destinationEqualsOrigin: '{destination}不能等于{origin}',
        timeOrderInvalid: 'ETA时间不能小于ETD',
        trackingSaveInvalid: '运踪节点缺少运单号或节点标识，无法保存'
      },
      tags: {
        bl: '提单',
        express: '快递',
        land: '陆运',
        rail: '铁路',
        waybill: '运单'
      },
      statuses: {
        PENDING: '待处理',
        IN_PROGRESS: '进行中',
        COMPLETED: '已完成'
      },
      exceptionLevels: {
        normal: '无异常',
        minor: '一般',
        major: '严重',
        critical: '紧急'
      }
    }
  },
  common: {
    yes: '是',
    no: '否',
    cancel: '取消',
    noData: '暂无数据',
    totalItems: '共 {count} 个'
  },
  detail: {
    tabs: {
      basic: '基础信息',
      products: '商品明细',
      tracking: '运踪',
      cost: '费用',
      billing: '账单',
      files: '文件管理',
      bizStatus: '业务状态'
    },
    sections: {
      base: '委托单基础信息',
      createBase: '基础信息',
      source: '来源选择',
      bizTags: '业务标签',
      logistics: '物流信息',
      party: '收发通信息',
      supplier: '供应商信息',
      weightVolume: '件重尺',
      containerGroup: '箱型组',
      products: '商品明细',
      tracking: '运单运踪',
      cost: '费用信息',
      billing: '账单信息',
      files: '文件管理',
      bizStatus: '业务状态'
    },
    supplierExternalLink: {
      open: '打开链接'
    },
    fedexFileUploadRetry: {
      title: 'FedEx 文件上传至 eTower 失败',
      description: '快递下单已成功，无需重复下单。请重新上传本次选择的文件。',
      action: '重新上传'
    },
    productFilterTitle: '商品明细筛选',
    productSummary: '共 {qty} 件 / 共 {boxes} 箱 / 总净额 USD {amount}',
    productSummaryFields: {
      totalQuantity: '总个数',
      productAmount: '商品金额',
      totalTax: '总税额',
      customsAmount: '报关货值',
      clearanceAmount: '清关货值'
    },
    statusLabels: {
      price: '运价',
      shippingSpace: '舱位'
    },
    unknownOperator: '未知用户',
    basicFields: {
      expectShipDate: '期望发货时间',
      actShipDate: '实际发货时间',
      expectArrivalDate: '期望到货时间',
      actArrivalDate: '实际到货时间',
      updater: '更新人'
    },
    logisticsFields: {
      crossBorder: '是否跨境',
      logisticsFlow: '物流流向',
      goodsValue: '货值'
    },
    weightVolumeFields: {
      source: '数据来源',
      totalQty: '总个数',
      totalBoxQty: '纸箱数',
      totalVolume: '总体积',
      totalWeight: '总重量',
      chargeableWeight: '计费重',
      length: '长',
      width: '宽',
      height: '高'
    },
    weightVolumeRows: {
      expected: '理论值',
      warehouse: '仓库数据',
      forwarder: '货代数据'
    },
    containerFields: {
      containerType: '箱型',
      containerQty: '数量',
      outboxQty: '件数',
      weight: '重量(KGS)',
      size: '尺寸（长×宽×高 cm）'
    },
    productFields: {
      lineNo: '行号',
      skuCode: 'SKU / 物料编码',
      productName: '产品名称',
      relatePlanNo: '关联运输计划单号',
      relateFhNo: '关联发货申请单号',
      planNo: '来源计划单号',
      fhNo: '关联FH单号',
      originOrderNo: '上层订单号',
      originOrderType: '上层单据类别',
      productModel: '产品型号',
      brand: '品牌',
      specialAttributes: '货品特殊属性',
      barCode: 'UPC条码',
      pcsQty: '数量',
      boxGauge: '外箱规格',
      stdBoxQty: '标箱数量',
      actualBoxQty: '实际箱数',
      packingMethod: '包装方式',
      unit: '计量单位',
      unitPrice: '单价',
      amtNet: '不含税金额',
      amtNetUntaxed: '未税金额',
      amountOrigin: '原金额',
      unitPriceOrigin: '原单价',
      unitPriceAll: '含税单价',
      unitPriceNet: '不含税单价',
      amtnFh: '含税金额',
      tax: '税额',
      taxRto: '税率',
      unitPriceQg: '清关不含税单价',
      amountNetQg: '清关不含税金额',
      amountTaxQg: '清关税额',
      amountAllQg: '清关含税金额',
      currencyQg: '清关货币',
      unitPriceBg: '报关不含税单价',
      amountNetBg: '报关不含税金额',
      amountTaxBg: '报关税额',
      amountAllBg: '报关含税金额',
      currencyBg: '报关货币',
      hsCodeLine: '海关编码',
      cusPoNo: '客户 PO 号',
      cnDesc: '中文描述',
      enDesc: '英文描述',
      customsDecl: '海关申报',
      boxNo: '箱号',
      snNo: 'SN号',
      snNos: 'SN号',
      containerNo: '集装箱柜号',
      sealNo: '封条号',
      cabinetSealNo: '柜号（封条号）',
      palletNo: '栈板号'
    },
    productActions: {
      add: '添加商品',
      batchImport: '批量导入',
      edit: '编辑',
      copy: '复制',
      delete: '删除',
      deleteConfirm: '确认删除该商品明细？删除后需保存才会生效。',
      downloadTemplate: '下载模板',
      selectImportFile: '选择 Excel 导入'
    },
    productImport: {
      title: '批量导入商品明细',
      description: '请先下载模板，按模板填写后再导入。导入结果会追加到当前商品明细表格，保存委托单后生效。',
      templateFileName: '商品明细导入模板.xlsx'
    },
    partyFields: {
      partyType: '类型',
      company: '公司',
      contactName: '联系人',
      phone: '联系电话',
      country: '国家',
      province: '省/州',
      city: '城市',
      district: '区县',
      address: '详细地址',
      postcode: '邮编'
    },
    partyTypes: {
      shipper: '发货人',
      consignee: '收货人',
      notify: '通知人',
      customsShipper: '报关发货地址',
      customsConsignee: '报关收货地址',
      clearanceShipper: '清关发货地址',
      clearanceConsignee: '清关收货地址',
      actualPickup: '实际提货地',
      actualDelivery: '实际送达地'
    },
    tableFields: {
      consignmentNo: '运输委托单号',
      feeDirection: '收付类型',
      feeSegment: '费用归属',
      feeName: '费用名称',
      settlementObject: '结算对象',
      domesticForeign: '国内国外',
      costItem: '费用项',
      currency: '币种',
      exchangeRate: '汇率',
      billingUnit: '单位',
      quantity: '数量',
      unitPrice: '单价',
      inclusiveTaxPrice: '含税价',
      exclusiveTaxPrice: '不含税价',
      estimatedInclusiveTaxPrice: '预估金额（含税）',
      estimatedExclusiveTaxPrice: '预估金额（不含税）',
      taxRate: '税率',
      taxAmount: '税额',
      baseCurrency: '本位币币种',
      baseCurrencyAmount: '折合本位币金额',
      writeOffStatus: '核销状态',
      counterpartyBillNo: '对方账单号',
      writeOffAmount: '核销金额',
      unwrittenOffAmount: '未核销金额',
      writeOffDate: '核销日期',
      receiptPaymentDate: '收付日期',
      reconciliationStatus: '对账状态',
      invoiceType: '发票类型',
      invoiceTitle: '开票抬头',
      invoiceDate: '开票日期',
      invoiceNo: '发票号码',
      estimatePushStatus: '费用预估状态',
      settlementPushStatus: '费用结算状态',
      settlementFlag: '是否参与结算',
      waybillNo: '所属运单',
      nsAccrualNo: 'NS预提单号',
      createTime: '创建时间',
      createdBy: '创建人',
      modifyTime: '更新时间',
      modifiedBy: '更新人',
      amount: '金额',
      status: '状态',
      remark: '备注',
      billNo: '账单号',
      node: '节点',
      time: '时间',
      operator: '操作人',
      operation: '操作'
    },
    feeColumns: {
      settings: '设置列',
      hint: '同时控制应收、应付表格的列展示',
      search: '搜索列名称',
      autoSave: '调整后自动保存，下次登录沿用',
      saving: '正在保存列设置…',
      saved: '列设置已保存',
      loadFailed: '列设置加载失败，请重试后再调整',
      saveFailed: '列设置保存失败，请重试',
      retry: '重试',
      validationRevealed: '存在校验错误的隐藏列已临时显示，原列设置保持不变',
      consignmentModule: '运输委托单费用列设置',
      shipmentModule: '发货申请单费用列设置'
    },
    feeSummary: {
      total: '费用合计（含税）',
      subtotal: '小计（含税）'
    },
    feeEdit: {
      addRow: '新增行',
      edit: '编辑',
      save: '保存',
      cancel: '取消',
      delete: '删除',
      deleteConfirmTitle: '确认删除费用',
      deleteConfirmContent: '确定要删除费用“{name}”吗？',
      deleteSingleConfirmContent: '确认删除该费用项？删除后不可恢复',
      deleteSelectedConfirmContent: '确定要删除选中的 {count} 条费用吗？删除后保存生效。',
      confirmDelete: '确认删除',
      deleteSuccess: '费用删除成功',
      deleteFailed: '费用删除失败',
      selectRowsFirst: '请先勾选费用行',
      selectPlaceholder: '请选择',
      requiredPlaceholder: '必填',
      requiredMessage: '请填写{field}',
      validationFailed: '请补充必填费用字段',
      missingOrderId: '缺少订单ID，无法保存费用',
      orderId: '订单ID'
    },
    feeAutoImport: {
      partialHint: '部分费用未能自动带入，请手动补充',
      failedHint: '费用自动带入失败，请手动录入或点击重新导入',
      reimport: '重新导入',
      reimportSuccess: '运价费用已重新带入',
      reimportFailed: '运价费用重新带入失败'
    },
    feeConfirm: {
      billCreateBlocked: '运输委托单费用未确认，无法创建账单'
    },
    feeChangeRequest: {
      trigger: '申请更改费用',
      title: '费用更改',
      comparisonTitle: '更改前后对比',
      edit: '编辑',
      close: '关闭',
      submit: '提交',
      submitSuccess: '费用更改申请已提交审批',
      submitFailed: '费用更改申请提交失败',
      pendingQueryFailed: '查询费用更改审批状态失败',
      pendingNotice: '注：已存在当下更改内容待审批，待此次改动结束后方可再次进行费用调整。',
      before: '修改前',
      after: '修改后',
      cancel: '取消',
      add: '新增',
      delete: '删除'
    },
    feeChangeApproval: {
      back: '返回',
      title: '费用更改审批',
      comparisonTitle: '费用更改前后对比',
      consignmentNo: '运输委托单号',
      applicationNo: '费用更改申请单号',
      status: '申请状态',
      statusValues: {
        draft: '草稿',
        pending: '审批中',
        approved: '已通过',
        rejected: '已驳回'
      },
      submittedAt: '提交时间',
      remark: '申请备注',
      loadFailed: '费用更改审批详情加载失败',
      missingApplicationId: '缺少费用更改申请 ID'
    },
    feeAllocation: {
      trigger: '触发分摊',
      allocatedStatus: '已分摊至 {count} 张发货申请单',
      status: '关联 {count} 张发货申请单，分摊依据：计费重',
      sourceBanner: '本发货申请单的费用来自运输委托单 {sourceOrderNo} 自动分摊（计费重 {basisValue} / {basisTotal} = {ratio}）。如需调整请在运输委托单的费用页签中修改后重新触发分摊。',
      title: '费用分摊',
      modalTip: '将运输委托单 {consignmentNo} 的费用，按各发货申请单的计费重比例自动分摊。费用变更后可重新触发。',
      relatedShipments: '关联发货申请单',
      confirm: '确认分摊',
      saveBeforeAllocate: '请先保存费用后再分摊',
      confirmBeforeAllocate: '费用未确认，请先在列表页批量确认费用后再分摊',
      noRelatedShipments: '当前无关联发货申请单，无法分摊',
      missingConsignmentId: '缺少运输委托单ID',
      previewTitle: '分摊金额预览',
      previewTitleWithShipment: '分摊金额预览（{shipmentNo} · {billingWeight} · {ratio}）',
      shipmentNo: '发货申请单号',
      chargeWeightKg: '计费重(kg)',
      ratio: '分摊比例',
      originalInclusiveAmount: '总金额（含税）',
      allocatedAmount: '分摊金额',
      loadPreviewFailed: '加载费用分摊预览失败',
      success: '费用分摊成功',
      failed: '费用分摊失败'
    },
    feeEnums: {
      feeType: {
        receivable: '应收',
        payable: '应付'
      },
      domesticForeign: {
        domestic: '国内',
        foreign: '国外'
      },
      writeOffStatus: {
        unwritten: '未核销',
        written: '已核销',
        partial: '部分核销'
      },
      reconciliationStatus: {
        unchecked: '未对账',
        checked: '已对账',
        rejected: '已驳回'
      },
      pushStatus: {
        unpushed: '未推送',
        pushed: '已推送'
      },
      settlementPushStatus: {
        unsettled: '未结算',
        settled: '已结算'
      },
      settlementFlag: {
        Y: '是',
        N: '否'
      }
    },
    customerVisible: '客户可见',
    fileFields: {
      fileName: '文件名',
      fileType: '文件类型',
      fileFormat: '文件格式',
      uploader: '上传人',
      uploadTime: '上传时间',
      fileSize: '文件大小',
      source: '来源',
      actions: '操作'
    },
    businessStatusFields: {
      logSeq: '序号',
      opTime: '操作时间',
      opUser: '操作人',
      content: '操作内容'
    },
    fileActions: {
      upload: '上传文件',
      importReport: '导入报告',
      download: '下载',
      delete: '删除'
    },
    deleteFileConfirm: '确定删除文件「{fileName}」吗？',
    uploadFile: {
      title: '上传文件',
      fileType: '文件类型',
      fileTypePlaceholder: '请选择文件类型',
      file: '文件',
      selectFile: '选择本地文件',
      filePlaceholder: '未选择文件',
      fileTypeOptions: {
        proofOfDelivery: '签收单',
        customsInvoice: '报关发票',
        customsPackingList: '报关箱单',
        customsContract: '报关合同',
        clearanceInvoice: '清关发票',
        clearancePackingList: '清关箱单',
        bookingNote: '委托单',
        supplierBill: '供应商账单',
        expressWaybill: '快递面单',
        batteryLetter: '电池信',
        certificateOfOrigin: '原产地证书',
        finalReviewNotice: '审结通知书'
      }
    },
    importReport: {
      title: '导入报告',
      searchPlaceholder: '搜索标题 / 产品型号 / 认证机构',
      selectedCount: '已选 {count} 项',
      confirm: '确认（已选 {count} 份）',
      duplicateSkipped: '部分报告已导入，已自动跳过',
      categories: {
        'cert-type-root': '证书类型',
        'cert-emc-rf': 'EMC/RF/安规认证',
        'cert-agency': '代理服务',
        'cert-function': '功能/性能认证',
        'cert-chemical': '化学认证',
        'cert-energy': '能效认证',
        'cert-training': '培训/咨询服务',
        'cert-factory': '审厂服务',
        'cert-bio': '生物认证',
        'cert-authorization': '授权服务',
        'cert-network': '网络安全认证',
        'cert-transport': '运输认证',
        'cert-registration': '注册认证',
        'cert-other': '其他'
      },
      noSelection: '请先选择要导入的报告',
      success: '报告导入成功',
      failed: '报告导入失败，请重试',
      columns: {
        countryRegion: '国家/地区',
        title: '标题',
        productCategory: '产品类别',
        certType: '证书类型',
        certProject: '认证项目',
        productModel: '产品型号',
        certOrg: '认证机构',
        effectiveDate: '生效时间',
        expiryDate: '失效时间',
        actions: '操作'
      }
    },
    printModal: {
      title: '打印',
      description: '选择模板并生成打印文档',
      template: '打印模板',
      templatePlaceholder: '请选择打印模板',
      templatesLoading: '模板加载中...',
      noTemplates: '暂无可用模板',
      bill: '账单',
      billPlaceholder: '请选择账单',
      noBills: '当前委托单暂无账单',
      orderIdMissing: '订单ID不存在，无法打印',
      fileName: '文件名',
      fileNamePlaceholder: '请输入文件名',
      fileNameSuffix: '（系统自动追加扩展名）',
      fileType: '文件类型',
      fileTypePlaceholder: '请选择文件类型',
      fileTypeOptions: {
        bookingNote: '委托单',
        supplierBill: '供应商账单'
      },
      saveToFileManagement: '保存到文件管理',
      cancelButton: '取消',
      generateButton: '生成',
      generatingButton: '生成中...',
      generateSuccess: '打印文档已生成',
      generateFailed: '打印文档生成失败',
      generateAndSaveSuccess: '打印文档已生成并保存至文件管理',
      exportThenSaveTip: '已打开报表，请在查看器中选择导出格式，文件会自动保存至文件管理',
      saveToFileManagementFailed: '保存至文件管理失败',
      templateDocumentMissing: '所选模板缺少云存储文件，无法保存到文件管理，请先在模板配置中保存设计稿',
      statusRecordFailed: '打印文档已生成，但业务状态记录失败，请联系管理员',
      templateRequired: '请选择打印模板',
      fileNameRequired: '请输入文件名',
      fileTypeRequired: '请选择文件类型',
      billRequired: '请选择账单',
      loadTemplatesFailed: '加载打印模板列表失败',
      loadBillsFailed: '加载委托单账单失败'
    }
  },
  externalCommon: {
    language: {
      zh: '中文',
      en: 'EN'
    },
    readonly: '只读',
    required: '必填',
    saved: '已保存',
    empty: {
      route: '暂无路线信息',
      contactAddress: '暂无收发通信息',
      containerGroup: '暂无箱型组信息',
      vehicleGroup: '暂无车辆组信息',
      bulkCargo: '暂无货物信息',
      cargoGroup: '暂无货物组信息',
      productInfo: '暂无商品明细',
      quotationDetail: '暂无报价明细',
      filesFromConsignor: '暂无委托方提供的相关文件',
      waybill: '暂无运单，请新增运单后填写',
      packing: '暂无装箱清单',
      trackingNode: '暂无运踪节点配置',
      supplierFiles: '暂无供应商上传文件',
      businessStatus: '暂无操作时间记录'
    },
    sections: {
      consignmentNo: '委托单编号',
      basicInfo: '基本信息',
      supplierInfo: '供应商信息',
      routeInfo: '路线信息',
      contactAddress: '收发通信息',
      productInfo: '商品明细',
      quotationDetail: '报价明细',
      filesFromConsignor: '委托方附件',
      waybillList: '运单列表',
      packingList: '装箱清单',
      trackingNodes: '运踪节点',
      businessStatus: '操作时间记录'
    },
    fields: {
      consignmentNo: '委托单号',
      entrustCompany: '委托公司',
      tradeTerms: '贸易条款',
      transportTerms: '运输条款',
      mainlineMode: '干线运输方式',
      goodsReadyTime: '货好时间',
      goodsType: '货品类型',
      cargoType: '货物类型',
      goodsValue: '货值',
      productName: '品名',
      hsCode: 'HS Code',
      expectShipDate: '期望发货时间',
      expectArrivalDate: '期望到货时间',
      supplierName: '供应商名称',
      contactName: '联系人',
      contactPhone: '联系电话',
      email: '邮箱',
      type: '类型',
      company: '公司',
      country: '国家',
      province: '省/州',
      city: '城市',
      district: '区县',
      address: '详细地址',
      status: '状态',
      exceptionLevel: '异常等级',
      estimatedTime: '预计时间',
      actualTime: '实际时间',
      exceptionType: '异常类型',
      estimatedRemark: '预计备注',
      actualRemark: '实际备注',
      exceptionRemark: '异常备注',
      supplierRemark: '供应商备注'
    },
    partyTypes: {
      shipper: '发货人',
      consignee: '收货人',
      notify: '通知人',
      shipperAddress: '发货地址',
      consigneeAddress: '收货地址',
      notifyAddress: '通知地址',
      actualPickup: '实际提货地',
      actualDelivery: '实际送达地'
    },
    routeTypes: {
      originWarehouse: '起运仓库',
      originLocation: '起运地',
      originCountry: '起运国',
      loadingPort: '起运港',
      loadingAirport: '起运机场',
      loadingHub: '起运枢纽',
      destinationPort: '目的港',
      destinationAirport: '目的机场',
      destinationHub: '目的枢纽',
      destinationCountry: '目的国',
      destinationLocation: '目的地',
      destinationWarehouse: '目的仓库'
    },
    routeAddress: {
      expand: '展开',
      collapse: '收起'
    },
    cargoGroupTitles: {
      container: '箱型组',
      vehicle: '车辆组',
      bulkCargo: '货物信息',
      cargo: '货物组'
    },
    cargoColumns: {
      containerType: '箱型',
      quantity: '数量',
      pieces: '件数',
      weightKgs: '重量(KGS)',
      sizeM: '尺寸(长x宽x高 M)',
      vehicleType: '车辆类型',
      brand: '品牌',
      model: '型号',
      vehicleLength: '车长(M)',
      vehicleWidth: '车宽(M)',
      vehicleHeight: '车高(M)',
      grossWeightKgs: '毛重(KGS)',
      cargoKind: '货种',
      tonnageMt: '吨位(MT)',
      volumeCbm: '体积(CBM)',
      stowageFactor: '积载因数',
      packagingType: '包装方式',
      packaging: '包装',
      palletSize: '托盘尺寸',
      palletQty: '托盘数量',
      remark: '备注'
    },
    productColumnResize: '拖动调整“{column}”列宽，双击恢复自适应；也可用左右方向键调整、回车恢复',
    productColumns: {
      productName: '商品名称',
      skuCode: 'SKU',
      relateFhNo: '关联发货申请单号',
      pcsQty: '数量',
      boxGauge: '包装标箱数量',
      actualBoxQty: '实际箱数',
      unitPrice: '单价',
      amtnFh: '金额',
      cnDesc: '中文描述',
      enDesc: '英文描述',
      hsCodeLine: 'HS编码'
    },
    transportSegmentLabels: {
      prePort: '港前',
      main: '干线',
      lastMile: '尾程'
    },
    trackingStatuses: {
      PENDING: '待处理',
      IN_PROGRESS: '进行中',
      COMPLETED: '已完成'
    },
    trackingExceptionLevels: {
      normal: '正常',
      minor: '一般',
      major: '重要',
      critical: '紧急'
    },
    transitTypes: {
      direct: '直达',
      transit: '中转'
    },
    placeholders: {
      select: '请选择',
      selectOrInput: '请选择或输入{field}',
      example: '如：{value}',
      remark: '请输入备注信息',
      supplierRemark: '请输入供应商备注',
      waybillNo: '请输入运单号',
      expressWaybillNo: '请输入快递运单号',
      seaBlNo: '请输入 HBL/MBL 单号',
      airBlNo: '请输入 HAWB/MAWB 单号',
      vesselName: '请输入船名',
      voyageNo: '请输入航次',
      phone: '请输入电话',
      vehicleLicence: '请输入车牌号',
      vehicleType: '请输入车型',
      trainNo: '请输入车次',
      estimatedTime: '预计时间',
      actualTime: '实际时间',
      exceptionType: '请输入异常类型',
      estimatedRemark: '请输入预计备注',
      actualRemark: '请输入实际备注',
      exceptionRemark: '请输入异常备注'
    }
  },
  quotationDetailTable: {
    empty: '暂无报价明细',
    airRateUnits: {
      normal: '标准价',
      minimum: 'Min'
    },
    columns: {
      feeCategory: '费用大类',
      feeName: '费用名称',
      feeType: '费用类型',
      containerType: '箱型',
      chargeWeight: '重量段',
      unit: '单位',
      currency: '币种',
      unitPrice: '单价',
      quantity: '数量',
      amount: '金额',
      originalUnitPrice: '原始单价',
      originalQuantity: '原始数量',
      originalAmount: '原始金额',
      confirmUnitPrice: '确认单价',
      confirmQuantity: '确认数量',
      confirmAmount: '确认金额',
      diffAmount: '差异金额',
      diffRate: '差异率',
      operation: '操作',
      remarks: '备注',
      min: '最小',
      max: '最大',
      densityDegree: '密度等级'
    }
  },
  spaceInquiryModal: {
    title: '询舱',
    summary: {
      consignmentNo: '委托单号',
      origin: '起运地',
      destination: '目的地',
      expectedShip: '期望发货'
    },
    completion: {
      completed: '已完善',
      pending: '待完善',
      warning: '请先在委托单中完善{title}所有字段后再发送询舱邮件'
    },
    templateNames: {
      SEA_FCL: '海运整箱-询舱确认邀请',
      SEA_LCL: '海运拼箱-询舱确认邀请',
      SEA_RORO: '海运滚装轮-询舱确认邀请',
      SEA_BULK: '海运散杂货-询舱确认邀请',
      AIR: '空运-询舱确认邀请',
      LAND_PRE_PORT: '港前陆运-询舱确认邀请',
      LAND_FINAL: '尾程陆运-询舱确认邀请',
      localFallbackSuffix: '本地兜底'
    },
    variables: {
      supplierContactName: '供应商联系人名称',
      entrustCompanyName: '委托主体公司',
      supplierName: '供应商名称',
      consignmentNo: '委托单号',
      consignmentCompanyName: '委托公司名称',
      transportSegment: '本段运输段落',
      segmentTransportMode: '本段运输业务类型',
      tradeTerms: '贸易条款',
      transportTerms: '运输条款',
      cargoReadyTime: '货好时间',
      goodsType: '货品类型',
      productName: '品名',
      goodsValue: '货值',
      originWarehouse: '起运仓库',
      loadingPortName: '起运港',
      originCountryName: '起运国',
      destinationPortName: '目的港',
      destinationCountryName: '目的国',
      destinationPlace: '目的地',
      cargoGroupTitle: '箱型组/货物组/车辆组/货物信息标题',
      containerGroupTable: '箱型组表格',
      cargoGroupTable: '箱型组/货物组/车辆组/货物信息表格',
      quotationDetailTable: '报价明细表格',
      spaceInquiryUrl: '询舱确认链接',
      expectedDepartureTime: '期望发货时间',
      expectedArrivalTime: '期望到货时间',
      spaceInquiryDeadline: '询舱截止时间',
      contactName: '联系人',
      contactPhone: '联系方式',
      contactEmail: '邮箱'
    },
    link: {
      title: '询舱链接',
      copy: '复制'
    },
    report: {
      title: '供应商报舱信息',
      tip: '供应商已提交报舱信息，请选择该记录并确认舱位。确认舱位前可继续发起询舱。',
      empty: '未查询到可确认的供应商报舱信息，请刷新后重试',
      confirmTitle: '确认舱位',
      confirmContent: '确认后将正式回写船期、航次及舱位状态，是否继续？',
      columns: {
        bookingNo: '询舱编号',
        submittedAt: '报舱时间',
        carrier: '承运人/航司',
        transitType: '直达/中转',
        transitPort: '中转港/机场',
        transitDays: '运输天数',
        vesselOrAircraft: '船名/机型',
        voyageOrFlight: '航次/航班号',
        routeCode: '航线代码',
        etd: 'ETD',
        eta: 'ETA',
        pickupTime: '提货时间',
        supplierRemark: '供应商备注'
      }
    },
    sendInfo: {
      title: '发送信息',
      consignorOffice: '委托主体公司',
      consignorOfficePlaceholder: '请选择委托主体公司',
      messageTemplate: '邮件模板',
      messageTemplatePlaceholder: '请选择邮件模板',
      supplier: '发送供应商',
      supplierContact: '供应商联系人',
      supplierEmail: '供应商邮箱',
      recipientEmails: '收件邮箱',
      recipientEmailsPlaceholder: '请选择或输入收件邮箱',
      emailContent: '邮件内容',
      editorHint: '支持富文本编辑，可直接输入占位符，语法：{variableToken}、{arrayToken}、{objectToken}',
      editorPlaceholder: '请输入邮件内容，使用 {variableToken} 作为占位符...'
    },
    attachments: {
      title: '附随附件',
      addIsf: '邮件模板展示是否添加ISF',
      addCabinetInvoice: '邮件模板展示是否添加柜明细发票'
    },
    defaultEmail: {
      greeting: '尊敬的 <strong>{supplierContactName}</strong>：您好！',
      intro: '<strong>{entrustCompanyName}</strong> 现诚挚邀请贵司 <strong>{supplierName}</strong> 确认以下委托单的舱位信息。',
      consignmentSummary: '【委托单概况】',
      routeInfo: '【路线信息】',
      quotationDetail: '【报价明细】',
      participation: '【参与方式及链接】',
      participationText: '请贵司通过以下链接登录确认舱位信息，填写航程详情（船公司、船名航次、ETD/ETA等）：',
      openLink: '点击进入：',
      importantTime: '【重要时间节点】',
      contactTip: '如有任何疑问，请随时通过以下方式联系：',
      cooperation: '期待与贵司的合作！',
      closing: '顺颂商祺！',
      labels: {
        consignmentNo: '委托单号',
        consignmentCompany: '委托公司',
        transportSegment: '运输段落',
        segmentTransportMode: '本段运输业务类型',
        tradeTerms: '贸易条款',
        transportTerms: '运输条款',
        cargoReadyTime: '货好时间',
        goodsType: '货品类型',
        productName: '品名',
        goodsValue: '货值',
        originWarehouse: '起运仓库',
        loadingPort: '起运港',
        originCountry: '起运国',
        destinationPort: '目的港',
        destinationCountry: '目的国',
        destinationPlace: '目的地',
        expectedDepartureTime: '期望发货时间',
        expectedArrivalTime: '期望到货时间',
        spaceInquiryDeadline: '询舱截止',
        contactName: '联系人',
        contactPhone: '电话',
        contactEmail: '邮箱'
      }
    },
    actions: {
      cancel: '取消',
      sendEmail: '发送邮件',
      confirmSpace: '确认舱位'
    },
    messages: {
      templateParamsParseFailed: '解析询舱邮件模板参数失败',
      templateLoadFailed: '询舱邮件模板加载失败，已使用本地兜底模板',
      supplementalDetailLoadFailed: '加载询舱详情补充数据失败',
      quotationBasicDataLoadFailed: '加载询舱报价明细基础数据失败',
      copyUnsupported: '当前浏览器不支持自动复制',
      orderIdRequired: '缺少委托单ID，无法生成询舱链接',
      copySuccess: '复制成功',
      copyFailed: '复制失败',
      insertVariableFailed: '插入询舱邮件变量失败',
      recipientRequired: '请填写收件邮箱',
      emailContentRequired: '请填写邮件内容',
      alreadyConfirmed: '舱位已确认，不能再次发起询舱',
      reportSelectionRequired: '请选择需要确认的报舱信息',
      confirmSuccess: '舱位确认成功',
      confirmFailed: '舱位确认失败'
    }
  },
  spaceBookingExternal: {
    title: '询舱确认',
    subtitle: '请确认委托信息并填写航程信息',
    infoTip: '本页面为供应商外部链接，仅供本次询舱使用。请确认信息后填写航程信息并提交。',
    submitted: {
      title: '询舱信息已提交',
      description: '报舱信息已提交，正在等待委托方确认，感谢配合。',
      submittedTime: '提交时间：{time}'
    },
    voyage: {
      title: '航程信息',
      carrier: '船公司',
      vesselName: '船名',
      voyageNo: '航次',
      routeCode: '航线代码',
      etd: 'ETD',
      eta: 'ETA',
      airline: '航空公司',
      aircraftType: '机型',
      flightNo: '航班号',
      pickupTime: '提货时间',
      transitType: '直达/中转',
      transitPort: '中转港',
      transitDays: '航程(天)',
      supplierRemark: '供应商备注'
    },
    actions: {
      submit: '提交询舱信息'
    },
    confirmDialog: {
      title: '确认提交询舱信息？',
      content: '提交后舱位状态将变为确认，信息不可修改。',
      okText: '确认提交'
    },
    messages: {
      submitSuccess: '询舱信息已提交',
      submitFailed: '提交询舱信息失败，请重试',
      linkIdRequired: '缺少询舱链接ID',
      loadDisplayNameFailed: '解析询舱展示名称失败',
      carrierLoadFailed: '加载船公司数据失败',
      airlineLoadFailed: '加载航空公司数据失败',
      loadFailed: '加载询舱信息失败',
      submitHint: '提交后舱位状态将变为确认，信息不可修改'
    }
  },
  supplierConfirmExternal: {
    title: '委托确认',
    infoTip: '本页面为供应商外部链接，仅供本次委托确认使用。点击「接收委托」后可查看后续附件、货物及运踪信息。',
    headerDescription: {
      pending: '请确认委托信息并完成接收操作',
      consigned: '委托已接收，请填写运单信息、货物信息并上传相关文件'
    },
    confirmHint: {
      cctower: '点击后委托单状态将变更为“已委托”，可进行费用对账、下载附件并填写货物信息',
      normal: '点击后委托单状态将变更为“已委托”，可查看后续附件、货物及运踪信息'
    },
    lockReasons: {
      external: '货物送达已超过7天，所有字段不可修改。如有问题请联系委托方。',
      reconciliationApproved: '供应商对账已审批通过，报价明细已确认。运单、货物等信息仍可继续编辑。',
      reconciliationPending: '供应商对账已提交审批，报价明细不可修改。运单、货物等信息仍可继续编辑。'
    },
    rejected: {
      title: '对账审批已驳回',
      reason: '驳回原因：{reason}',
      defaultReason: '审批人未填写驳回原因',
      action: '请根据驳回意见调整费用后重新确认对账。'
    },
    waybill: {
      title: '运单列表',
      add: '新增运单',
      requiredTip: '全程委托需填写港前、干线、尾程三条必填运单，必填运单不可删除。',
      requiredTipFull: '全程委托需填写港前、干线、尾程三条必填运单，必填运单不可删除。',
      requiredTipPreMain: '港前+干线委托需填写港前、干线两条必填运单，必填运单不可删除。',
      requiredTipMainLast: '干线+尾程委托需填写干线、尾程两条必填运单，必填运单不可删除。',
      requiredTag: '必填',
      submittedTag: '已提交',
      displayNo: '运单 {index}',
      segmentTitle: '{segment}运单',
      deleteRequiredTitle: '全程委托单港前、干线、尾程运单必填，不可删除',
      deleteRequiredTitleFull: '全程委托单港前、干线、尾程运单必填，不可删除',
      deleteRequiredTitlePreMain: '港前+干线委托单港前、干线运单必填，不可删除',
      deleteRequiredTitleMainLast: '干线+尾程委托单干线、尾程运单必填，不可删除',
      baseInfo: '运单基础信息',
      copyVoyage: '复制航程信息',
      saveWaybill: '保存运单信息',
      submitWaybill: '提交运单信息',
      businessType: '运输业务类型',
      transportSegment: '运输段落',
      selectTransportSegment: '选择运输段落',
      routeLockedAfterSave: '首次保存后，运输业务类型和运输段落不可修改',
      changeRouteTitle: '确认切换运单类型？',
      changeRouteContent: '切换后，不适用于新业务类型的运单字段将被清空，请确认是否继续。',
      blType: '运单类型',
      airBlNo: '空运单号',
      seaBlNo: '提单号',
      airBlHint: '空运：分运单/主运单',
      seaBlHint: '海运：HBL/MBL',
      expressWaybillNo: '快递运单号',
      railwayWaybillNo: '铁路运单号',
      carrierWaybillNo: '承运商运单号',
      vesselName: '船名',
      voyageNo: '航次',
      flightNo: '航班号',
      routeCode: '航线代码',
      airline: '航空公司',
      expressCompany: '快递公司',
      expressProduct: '快递产品',
      vehicleLicence: '车牌号',
      driverName: '司机姓名',
      driverPhone: '电话',
      driverIdNo: '身份证号',
      vehicleType: '车型',
      carrier: '承运商',
      railwayCarrier: '铁路承运商',
      trainNo: '车次',
      originPort: '起运港',
      destinationPort: '目的港',
      originAirport: '起运机场',
      destinationAirport: '目的机场',
      originPlace: '起运地',
      destinationPlace: '目的地',
      segmentOrigin: '本段起运地',
      segmentDestination: '本段目的地',
      supplierRemark: '供应商备注',
      expand: '展开',
      collapse: '收起',
      modeFallback: '运单'
    },
    cargoSummary: {
      title: '实际货物信息总计',
      summarizePacking: '汇总装箱清单',
      save: '保存实际货物信息',
      pieces: '纸箱数',
      grossWeight: '毛重(KGS)',
      volume: '体积(CBM)',
      chargeableWeight: '计费重(KGS)',
      palletSize: '托盘尺寸(长×宽×高 cm)',
      palletSizePlaceholder: '如 120×80×100 或 120',
      palletQty: '托盘数量'
    },
    packing: {
      title: '装箱清单',
      downloadTemplate: '下载模板',
      importExcel: '导入 Excel',
      addRow: '新增行',
      operation: '操作'
    },
    tracking: {
      title: '运踪节点',
      save: '保存运踪信息'
    },
    files: {
      download: '下载',
      filesFromConsignor: '委托方提供附件',
      uploadSection: '上传文件',
      businessStatus: '操作时间记录'
    },
    upload: {
      title: '上传文件',
      fileType: '文件类型',
      file: '上传文件',
      chooseFile: '选择文件',
      noFileSelected: '未选择文件'
    },
    importPacking: {
      title: '导入装箱清单',
      summary: '已解析 {count} 行装箱清单，确认后将填充到当前运单。'
    },
    reconciliation: {
      acceptFirst: '供应商接受委托后才可确认费用对账',
      successWithBill: '结算单 {billNo} 已生成，待审批',
      success: '结算单已生成，待审批',
      failed: '确认费用对账失败，请重试'
    },
    quotationReconciliation: {
      editable: '可编辑',
      delete: '删除',
      addFee: '添加费用项',
      emptyEditable: '暂无费用项，请点击下方按钮添加',
      infoTip: '请核对报价明细中的费用项，可修改确认单价/数量、删除不适用费用、添加遗漏费用。确认无误后点击下方按钮，系统将自动生成结算单并提交至委托方 BPM 审批。',
      diffNote: '差异说明',
      optional: '（选填）',
      commonReasons: '常见原因',
      diffNotePlaceholder: '请说明费用调整的原因，以便委托方审批时参考。例如：近期燃油价格持续上涨，BAF 从 USD350 调整至 USD420；起运港 THC 因操作费率调整，从 USD180 调整至 USD200。',
      submit: '确认对账并生成结算单',
      submitHint: '确认后将自动生成结算单，进入委托方 BPM 审批流程',
      currencyTotal: '{currency} 合计 {amount}',
      diffReasonSeparator: '；',
      defaultSettlementObject: '供应商',
      feeCategories: {
        prePort: '港前',
        main: '干线',
        lastMile: '尾程',
        fullJourney: '全程'
      },
      feeUnits: {
        container: '柜',
        ticket: '票',
        day: '天'
      },
      feeNames: {
        truckingFee: '拖车费',
        customsDeclarationFee: '报关费',
        documentFee: '文件费',
        loadingFee: '装箱费',
        originThc: '起运港 THC',
        terminalSecurityFee: '码头安保费',
        storageFee: '仓储费',
        oceanFreight: '海运基本费',
        baf: 'BAF (燃油附加费)',
        caf: 'CAF (货币调整费)',
        pss: 'PSS (旺季附加费)',
        ebs: 'EBS (紧急燃油附加费)',
        portHandlingFee: '港口操作费',
        billOfLadingFee: '提单费',
        destinationThc: '目的港 THC',
        railTransferFee: '铁路转运费',
        bargeFee: '驳船费',
        telexReleaseFee: '电放费',
        agencyFee: '代理费',
        liftOnOffFee: '吊箱费',
        fumigationFee: '熏蒸费',
        inspectionFee: '检验费',
        insuranceFee: '保险费'
      },
      diffReasons: {
        truckingWaitingFeeIncrease: '拖车等待费增加',
        customsInspectionExtraFee: '报关查验产生额外费用',
        originOperationRateChange: '起运港操作费率调整',
        fuelSurchargeChange: '燃油附加费调整',
        spaceTightRateChange: '舱位紧张运价调整',
        peakSeasonSurchargeChange: '旺季附加费变动',
        destinationOperationRateChange: '目的港操作费率调整',
        deliveryAddressSurcharge: '派送地址产生附加费',
        storageOrDemurrageIncrease: '仓储或滞箱费用增加'
      },
      messages: {
        duplicateFeeName: '新增费用名称不能重复，请重新选择',
        duplicateFeeNameWithName: '新增费用名称「{name}」不能重复',
        diffNoteMax: '差异说明不能超过500字符',
        emptyFees: '费用明细不能为空',
        incompleteNewFee: '请补充完整新增费用项的费用大类和费用名称',
        noFeeChange: '至少需要修改一条费用价格后才能确认对账'
      }
    },
    actions: {
      accept: '接收委托'
    },
    confirmDialog: {
      acceptTitle: '确认接收委托？',
      acceptContent: '确认接收运输委托单 {consignmentNo} 后，委托状态将更新为已委托。',
      acceptOk: '接收委托',
      deleteWaybillContent: '确认删除运单 {name}？',
      deleteContent: '确认删除 {name}？'
    },
    messages: {
      downloadFileFailed: '下载文件失败',
      resolveContainerTypeFailed: '解析箱型名称失败',
      resolveDisplayNameFailed: '解析委托确认展示名称失败',
      tokenRequired: '缺少委托确认 token',
      loadFailed: '加载委托确认信息失败',
      loadBusinessStatusFailed: '加载操作时间记录失败',
      loadCctowerModeFailed: '加载东风环境配置失败',
      acceptSuccess: '已接收委托',
      acceptFailed: '接收委托失败，请重试',
      saveWaybillSuccess: '运单信息已保存',
      saveWaybillFailed: '保存运单信息失败',
      waybillModeRequired: '请选择运输业务类型',
      waybillSegmentRequired: '请选择运输段落',
      waybillRouteMismatch: '运输业务类型与运输段落不匹配，请重新选择',
      saveWaybillFirst: '请先保存运单信息',
      cargoRequired: '请填写纸箱数、毛重和体积',
      saveCargoSuccess: '实际货物信息已保存',
      saveCargoFailed: '保存实际货物信息失败',
      submitWaybillSuccess: '运单信息已提交',
      submitWaybillFailed: '提交运单信息失败',
      noTrackingNodeToSave: '暂无可保存的运踪节点',
      saveTrackingSuccess: '运踪信息已保存',
      saveTrackingFailed: '保存运踪信息失败',
      deleteWaybillTitle: '确认删除运单？',
      deleteWaybillSuccess: '运单已删除',
      downloadPackingTemplateFailed: '下载装箱清单模板失败',
      importPackingFailed: '导入装箱清单失败',
      importPackingFallbackFailed: '导入失败',
      importPackingSuccess: '装箱清单已导入',
      uploadSupplierFileSuccess: '文件已上传',
      uploadSupplierFileFailed: '上传供应商文件失败',
      deleteFileTitle: '确认删除文件？',
      deleteFileSuccess: '文件已删除'
    }
  },
  fields: {
    consignmentNo: '运输委托单号',
    orderStatus: '主状态',
    mergeStatus: '委托状态',
    priceStatus: '运价状态',
    shippingSpaceStatus: '舱位状态',
    transportSegment: '运输段落',
    relatePlanNo: '关联运输计划单号',
    relateFhNo: '关联发货申请单号',
    businessCategory: '业务类',
    fhCateg: '业务类编码',
    fhCategName: '业务类名称',
    regionCodePath: '区域编码',
    regionPath: '区域',
    costCenter: '成本中心编码',
    costCenterName: '成本中心',
    salesType: '销售模式编码',
    salesTypeName: '销售模式名称',
    bizDept: '业务部门编码',
    departmentName: '业务部门',
    relateConsignmentNo: '关联运输委托单号',
    orderSource: '来源',
    sourceType: '来源类型',
    goodsType: '货品信息',
    cusShortName: '客户简称',
    cusName: '客户名称',
    cusNo: '客户编码',
    customerNames: '客户',
    originWh: '发货仓库',
    createdAt: '创建时间',
    creator: '创建人',
    omsRemark: '订单备注',
    logisticsOperator: '物流操作员',
    updatedAt: '更新时间',
    consignor: '委托主体公司',
    customerConsignment: '是否客户指定',
    customsTradeTerm: '贸易条款（报关）',
    clearanceTradeTerm: '贸易条款（清关）',
    transportTerms: '运输条款',
    segmentTransportMode: '本段运输业务类型',
    hopeSegmentTransportMode: '期望本段运输业务类型',
    segmentOrigin: '本段起运地',
    segmentDestination: '本段目的地',
    destinationWh: '目的仓库',
    destinationWhCode: '目的仓库编码',
    mainlineOriginCountry: '干线起运国',
    mainlineDestCountry: '干线目的国',
    portOfLoadingCode: '起运港',
    portOfDischargeCode: '目的港',
    expectShipDate: '本段期望发货时间',
    actShipDate: '本段实际发货时间',
    expectArrivalDate: '本段期望到货时间',
    actArrivalDate: '本段实际到货时间',
    productName: '品名',
    englishProductName: '英文品名',
    chineseProductName: '中文品名',
    shippingMark: '唛头',
    hsCode: 'HS编码',
    originCountry: '原产国',
    customsFlag: '是否报关',
    customsType: '报关类型',
    exchangeRate: '汇率',
    amountCurrency: '总金额-币种',
    taxCurrency: '总税额-币种',
    totalAmount: '总金额-金额',
    totalTax: '总税额-税额',
    clearanceCurrency: '货值（清关总金额）-币种',
    totalAmountQg: '货值（清关总金额）-金额',
    cargoType: '货物类型',
    goodsReadyTimeType: '货好时间-类型',
    goodsReadyPeriod: '货好时间-时间段',
    goodsReadyDate: '货好时间-日期',
    goodsReadyTime: '货好时间-日期',
    tmsRemark: '运输备注',
    bizTags: '业务标签',
    volumeUnit: '体积单位',
    weightUnit: '重量单位',
    lengthUnit: '长度单位',
    weightCount: '计费重单位',
    totalQtyExpect: '总个数-理论值',
    totalVolumeExpect: '总体积-理论值',
    totalWeightExpect: '总重量-理论值',
    lengthExpect: '长-理论值',
    widthExpect: '宽-理论值',
    heightExpect: '高-理论值',
    totalWeightCountWh: '计费重-仓库数据',
    totalVolumeSupplier: '总体积-货代数据',
    totalWeightSupplier: '总重量-货代数据',
    totalWeightCountSupplier: '计费重-货代数据',
    supplierCode: '供应商编码',
    supplierSn: '供应商简称',
    supplierName: '供应商名称',
    contactName: '联系人',
    contactPhone: '联系电话',
    email: '邮箱',
    consignMailStatus: '委托邮件状态',
    priceConfirmStatus: '运价确认状态',
    shippingSpaceConfirmStatus: '舱位确认状态',
    feeConfirmStatus: '费用确认状态',
    relateInquiryNo: '关联询价单号',
    relatePriceNo: '关联运价号',
    currentTrackingNode: '当前运踪节点',
    supplierConfirmExternalLink: '委托供应商外链',
    operation: '操作'
  },
  filterFields: {
    consignmentNo: '委托单号',
    supplier: '供应商'
  },
  placeholders: {
    consignmentNo: '请输入委托单号，多个用逗号/空格分隔',
    orderStatus: '请选择主状态',
    mergeStatus: '请选择委托状态',
    priceStatus: '请选择运价状态',
    shippingSpaceStatus: '请选择舱位状态',
    feeConfirmStatus: '请选择费用确认状态',
    transportSegment: '请选择运输段落',
    segmentTransportMode: '请选择本段运输业务类型',
    hopeSegmentTransportMode: '请选择期望本段运输业务类型',
    supplierName: '请选择供应商名称',
    supplierShortName: '请选择供应商简称',
    segmentOrigin: '请选择本段起运地',
    segmentDestination: '请选择本段目的地',
    destinationWh: '请选择目的仓库',
    destinationWhCode: '请选择目的仓库编码',
    mainlineOriginCountry: '请选择干线起运国',
    mainlineDestCountry: '请选择干线目的国',
    portOfLoading: '请输入起运港代码',
    portOfDischarge: '请输入目的港代码',
    currentTrackingNode: '请选择或输入当前运踪节点',
    keyword: '请输入关键词',
    bizTagsSelect: '请输入或选择业务标签',
    batchKeyword: '请输入关键词，多个用逗号/空格分隔',
    select: '请选择',
    dateRange: '请选择日期范围',
    number: '请输入数字'
  },
  enums: {
    transportSegment: {
      prePort: '港前',
      main: '干线',
      final: '尾程',
      full: '全程',
      preMain: '港前+干线',
      mainLast: '干线+尾程'
    },
    transportMode: {
      fcl: '海运整箱',
      lcl: '海运拼箱',
      air: '空运',
      road: '陆运',
      rail: '铁路',
      express: '快递',
      roro: '海运滚装轮',
      bulk: '海运散杂货',
      other: '其他'
    },
    orderStatus: {
      created: '已创建',
      picking: '拣货中',
      operating: '正操作',
      completed: '已完成',
      frozen: '已冻结',
      cancelled: '已取消',
      approving: '审批中'
    },
    consignmentStatus: {
      notConsigned: '未委托',
      consigned: '已委托',
      cancelled: '已取消'
    },
    confirmStatus: {
      unconfirmed: '未确认',
      confirmed: '已确认',
      irrelevant: '无关'
    },
    shippingSpaceStatus: {
      reported: '已报舱'
    },
    consignMailStatus: {
      unsent: '未发送',
      sent: '已发送'
    },
    goodsType: {
      standard: '标准产品',
      marketing: '营销物料',
      rawMaterial: '原材料',
      gift: '赠品'
    },
    trackingNode: {
      collected: '已揽收',
      inTransit: '运输中',
      delivering: '派送中',
      signed: '已签收',
      exception: '签收异常'
    },
    trackingSource: {
      expressApi: '快递API',
      manual: '人工回填'
    }
  },
  expressOrderDialog,
  unfreezeDialog: {
    title: '确认解冻',
    content: '确认解冻运输委托单（{no}）？解冻后主状态将恢复为「正操作」。',
    okText: '确认解冻',
    cancelText: '取消'
  },
  messages: {
    loadListFailed: '加载运输委托单列表失败',
    loadDetailFailed: '加载运输委托单详情失败',
    detailIdMissing: '运输委托单ID不存在，无法加载详情',
    loadFeeFailed: '加载运输委托单费用失败',
    loadCountryFailed: '加载国家数据失败',
    loadDivisionFailed: '加载行政区划数据失败',
    loadOfficeFailed: '加载公司架构数据失败',
    transportPlanNotFound: '未找到运输计划单【{no}】，无法打开详情',
    transportPlanOpenFailed: '打开运输计划单详情失败，请重试',
    distributionShipmentNotFound: '未找到发货申请单【{no}】，无法打开详情',
    distributionShipmentOpenFailed: '打开发货申请单详情失败，请重试',
    createSuccess: '运输委托单新增成功',
    createFailed: '运输委托单新增失败',
    saveSuccess: '运输委托单保存成功',
    saveFailed: '运输委托单保存失败',
    customerSnapshotUnresolvedReadonly: '部分历史客户企业信息暂未恢复，本次仅锁定客户字段；其他信息仍可编辑保存',
    customerFieldNotMaintained: '{field}未维护（{customer}）',
    rateSelectRequired: '请先选择一条运价',
    ratePriceNoRequired: '所选运价缺少运价编码，无法确认',
    rateSupplierRequired: '所选运价缺少供应商企业信息，无法确认',
    rateConfirmSuccess: '运价确认成功',
    rateConfirmFailed: '运价确认失败，请重试',
    rateDetailMissing: '缺少运价ID，无法打开费用明细',
    loadFilesFailed: '加载运输委托单文件失败',
    loadBusinessStatusFailed: '加载运输委托单业务状态失败',
    fileIdMissing: '文件ID不存在，无法操作',
    fileRecordIdMissing: '文件记录ID不存在，无法删除',
    orderIdMissing: '订单ID不存在，无法上传文件',
    fileTypeRequired: '请选择文件类型',
    fileRequired: '请选择上传文件',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败，请重试',
    fedexFileRetryOrderMissing: '缺少快递下单记录，无法重新上传 FedEx 文件',
    fedexFileRetrySuccess: 'FedEx 文件已成功上传至 eTower',
    fedexFileRetryFailed: 'FedEx 文件重新上传失败，请稍后重试',
    downloadSuccess: '开始下载',
    downloadFailed: '下载失败，请重试',
    deleteFileSuccess: '文件删除成功',
    deleteFileFailed: '文件删除失败，请重试',
    customerVisibleUpdateSuccess: '客户可见状态已更新',
    customerVisibleUpdateFailed: '客户可见状态更新失败，请重试',
    inquirySuccess: '询价已发送，询价单号：{no}',
    inquiryAndRateSuccess: '运价已确认，询价已发送，询价单号：{no}',
    inquiryFailed: '询价发送失败',
    spaceInquiryEmailFailed: '发送询舱邮件失败，请重试',
    supplierEmailFailed: '发送供应商邮件失败，请重试',
    cancelConsignmentFailed: '取消委托失败，请重试',
    deleteConsignmentFailed: '删除委托单失败，请重试',
    consignedRateChangeForbidden: '当前运输委托单【{no}】已委托，不能更换运价',
    inquiryFclOnly: '当前仅支持海运整箱、海运拼箱、海运滚装轮、海运散杂货、空运、港前、尾程发送询价',
    inquiryTransportTermsRequired: '请选择运输条款',
    inquiryCargoTypeRequired: '请选择货物类型',
    inquiryDeadlineRequired: '请选择报价截止时间',
    inquiryDeadlineFutureRequired: '报价截止时间必须晚于当前时间',
    inquiryContactRequired: '请选择询价目标供应商联系人',
    inquiryContactEmailRequired: '已选供应商联系人邮箱不能为空',
    inquiryContainerRequired: '请填写至少一个有效箱型',
    inquiryCargoRequired: '请填写至少一个有效货物',
    inquiryVehicleRequired: '请填写至少一个有效车辆',
    inquiryBulkCargoRequired: '请填写至少一个有效散杂货货物信息',
    inquiryContainerCompleteRequired: '请完善箱型组所有字段后再确认',
    inquiryCargoCompleteRequired: '请完善货物组所有字段后再确认',
    inquiryVehicleCompleteRequired: '请完善车辆组所有字段后再确认',
    inquiryBulkCargoCompleteRequired: '请完善货物信息所有字段后再确认',
    contactPartyRequired: '收发通信息必须且只能有一条发货人和一条收货人',
    contactAddressRequired: '收发通联系人、联系电话、国家不能为空',
    customsContactAddressRequired: '报关/清关地址的联系电话不能为空',
    customsCountryLookupFailed: '无法确认港口所属国家，请检查港口资料后重试',
    provinceMustBeSelected: '收发通信息第 {row} 行的省州只能从搜索结果中选择',
    contactAddressIncompleteForSupplier: '请完善收发通必填信息（报关/清关地址仅要求联系电话）后再委托或联系供应商',
    amountNumberRequired: '金额字段必须是数字',
    vehicleGroupAtLeastOne: '车辆信息至少保留 1 行',
    bulkCargoInfoAtLeastOne: '散杂货货物信息至少保留 1 行',
    vehicleGroupRequiredFields: '请完善车辆信息第 {row} 行：车辆类型和数量必填，数量需为大于等于 1 的整数',
    bulkCargoInfoRequiredFields: '请完善散杂货货物信息第 {row} 行：货种和吨位必填，吨位需大于 0',
    productAtLeastOneRequired: '商品明细至少需要填写一行',
    productRequired: '请完善商品明细必填项：产品名称、件数、计量单位',
    productFirstInvalidField: '商品明细第 {rowIndex} 行：请填写{field}',
    productQtyInvalid: '商品明细第 {rowIndex} 行：件数必须为大于等于 1 的整数',
    productImportEmpty: '未读取到有效商品明细',
    productImportSuccess: '已导入 {count} 条商品明细',
    productImportFailed: '商品明细导入失败，请检查模板格式',
    offlineConfirmOrderIdRequired: '缺少委托单ID，无法线下委托供应商',
    offlineConfirmSuccess: '线下委托供应商成功，委托状态已更新为「已委托」',
    offlineConfirmFailed: '线下委托供应商失败，请重试',
    offlineSupplierStatusInvalid: '仅主状态为已创建或正操作且委托状态为未委托的运输委托单可线下委托供应商',
    offlineSupplierNameRequired: '请选择供应商',
    supplierSelectionRequired: '请选择供应商',
    offlineSupplierEmailInvalid: '请填写正确的邮箱',
    unfreezeOrderIdRequired: '缺少委托单ID，无法解冻',
    unfreezeStatusDisabled: '仅已冻结的运输委托单可以解冻',
    unfreezeSuccess: '运输委托单已解冻',
    unfreezeFailed: '解冻运输委托单失败，请重试',
    notifyPickingDisabled: '委托状态为已委托后才可通知拣货出库',
    batchFeeSelectRequired: '请先选择需要修改的运输委托单',
    batchFeeConfirmSuccess: '已确认 {count} 条委托单的费用',
    batchFeeCancelConfirmSuccess: '已取消确认 {count} 条委托单的费用',
    batchFeeConfirmFailed: '批量修改费用确认状态失败，请重试',
    batchCompleteSelectRequired: '请先选择需要完结的运输委托单',
    batchCompleteLoadFailed: '加载批量完结运单列表失败，请重试',
    batchCompleteSuccess: '已完结 {count} 条委托单',
    batchCompleteFailed: '批量完结失败，请重试',
    operationPending: '{action}功能待完善，委托单：{no}',
    reportNoFile: '所选报告暂无文件',
    loadReportFailed: '加载文控报告列表失败'
  }
}
